import {DateInterval} from "api/report";
import {http} from "../../http";
import {city} from "ca-plateform-organization-domain";
import {buildBonusGroupApiUrl} from "api/configuration";

export interface ExportDolibarrOrganizationsQueryBase
    extends city.colisactiv.organization.model.features
        .ExportDolibarrOrganizationsQueryBase {}

export const exportDolibarrOrganizations = async (
  period: DateInterval,
  organizationType: string
): Promise<string | null> => {
  const query: ExportDolibarrOrganizationsQueryBase = {
    type: "EXPORT_ORGANIZATIONS",
    payload: {
      period: {
        startDate: period.startDate,
        endDate: period.endDate
      },
      type: {
        type: organizationType
      }
    }
  }
  return http.fetchDownloadableFile(
    buildBonusGroupApiUrl(`/organizations/exportDolibarr`),
    "Une erreur est survenue lors de l'export Dolibarr des organisations",
    "post",
    JSON.stringify(query)
  );
};
